<template>
	<div class="login-container">
		<el-row>
			<el-col :span="15">
				<el-image src="/login_left.jpg" fit="fill"></el-image>
			</el-col>
			<el-col :span="9">
				<div style="margin-left: 20%;">
					<el-row>
						<el-image style="margin-top: 10%;width:400px;margin-left: -65px;" src="/login_logo.png" fit="none"></el-image>
					</el-row>
					<el-row style="margin-top: 10%;">
						<h1 style="font-size: 20px;">miniJD签单岛地址出租</h1>
					</el-row>
					<el-row>
						<span style="font-size: 16px;color:#aaa">COD签收地址出租（服务国家：泰国、菲律宾、</span>
						<br>
						<span style="font-size: 16px;color:#aaa">印尼、越南、马来，持续开发中......）</span>
					</el-row>
					<el-row style="margin-top: 10%;">
						<el-form :model="ruleForm2" :rules="rules2" status-icon ref="ruleForm2" label-position="left"
							label-width="0px" class="demo-ruleForm login-page">
							<span style="font-size: 16px;">用户名</span>
							<el-form-item prop="username">
								<el-input style="width: 70%;margin-top: 10px;" size="large" @keyup.enter.native=handleSubmit type="text" v-model="ruleForm2.username" auto-complete="off" placeholder="请输入用户名"></el-input>
							</el-form-item>
							<span style="font-size: 16px;">密码</span>
							<el-form-item prop="password">
								<el-input style="width: 70%;margin-top: 10px;" size="large" show-password @keyup.enter.native=handleSubmit type="password" v-model="ruleForm2.password" auto-complete="off" placeholder="请输入密码">
								</el-input>
							</el-form-item>
							<el-checkbox v-model="checked" class="rememberme">记住密码</el-checkbox>
							<el-form-item style="width:100%;margin-top: 20px;">
								<el-button :loading="this.$store.state.ajaxLoading" type="primary" style="width:70%;background-color: #3c37ff;font-size: 18px;" @click="handleSubmit">登录
								</el-button>
							</el-form-item>
						</el-form>
					</el-row>
					<el-row style="width: 70%;margin-top: 30px;">
						<el-divider><span style="color: #aaa;">战略合作伙伴</span></el-divider>
					</el-row>
					<el-row style="margin-top: 30px;">
						<el-image style="margin-left:35px;width: 320px;" src="/hb.png" fit="fill"></el-image>
						<!-- <el-image src="/hb.png" fit="none"></el-image> -->
					</el-row>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import storage from 'good-storage'
	import {
		login
	} from '@/api/login'
	import {
		createRoutes
	} from '@/tool/index'
	import {
		setToken
	} from '@/tool/cookie'
	import {
		asyncRoutes
	} from '@/router'
	import router from '@/router'
	import Qs from 'qs'
	export default {
		data() {
			return {
				ruleForm2: {
					username: '',
					password: '',
				},
				rules2: {
					// username: [{
					// 	required: true,
					// 	message: '请输入用户名',
					// 	trigger: 'blur'
					// }],
					// password: [{
					// 	required: true,
					// 	message: '请输入密码',
					// 	trigger: 'blur'
					// }]
				},
				checked: true
			}
		},
		methods: {
			handleSubmit(event) {
				this.$refs.ruleForm2.validate((valid) => {
					if (valid) {
						this.$store.commit('setAjaxLoading', true);
						login(Qs.stringify(this.ruleForm2)).then(response => {
							// 存储管理员的uid和token
							setToken('admin_name', response.result.nick_name);
							setToken('login_uid', response.result.id);
							setToken('token', response.result.token);
							if (response.result.id != 1) {
								// 存储用户的权限
								let data = createRoutes(asyncRoutes, response.result.role);
								// router.addRoutes(data)
								// let a = setToken('manager_role', JSON.stringify(data));
								storage.set('manager_role', JSON.stringify(data))
								storage.set('manager_role2', JSON.stringify(response.result.role))
							}
							//跳转到首页
							this.$router.push({
								path: '/'
							})
							this.$router.push('/')

						})
					} else {
						return false;
					}
				})
			}
		}
	};
</script>

<style scoped>
	.login-container {
		width: 100%;
		height: 100%;
		position: fixed;
	}
	/deep/ .el-input__inner{
		height: 45px;
		border-radius: 100px;
	}
	/deep/ button{
		height: 45px;
		border-radius: 100px;
	}
	/deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
		color:#aaa;
	}
	/deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
	    background-color: #3c37ff;
	    border-color: #3c37ff;
	}
</style>
